import React, { useState } from "react";
import headingImg from "../../assets/img/heading-img.png";
import bannerBg from "../../assets/img/bannr-img.jpg";
import colorBG from "../../assets/img/color-bg.jpg";
import blogDetail1 from "../../assets/img/blog-detail-img-1.jpg";
import blogDetail2 from "../../assets/img/blog-detail-img-2.jpg";
import blogDetail3 from "../../assets/img/blog-detail-img-3.jpg";
import blogDetail4 from "../../assets/img/blog-detail-img-4.jpg";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { faQuoteRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./BlogDetails.css";

const BlogDetails = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleClick = (e, index) => {
    e.preventDefault();

    setActiveIndex(activeIndex === index ? null : index);
  };
  const { id } = useParams();
  //   const navigate = useNavigate();

  return (
    <div>
      <section
        className="bannr-section"
        style={{
          backgroundImage: `url(${bannerBg})`,
        }}
      >
        <div className="container">
          <div className="bannr-text">
            <img src={headingImg} alt="icon" />
            <h2>Our Blogs</h2>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <NavLink to="/">Home</NavLink>
              </li>
              <li className="breadcrumb-item" aria-current="page">
                <NavLink to="/blogs">Blogs</NavLink>
              </li>
              <li className="breadcrumb-item" aria-current="page">
                Blog Details
              </li>
            </ol>
          </div>
        </div>
      </section>
      <section className="gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="blog-two our-blog hoverimg">
                <figure>
                  <img src={blogDetail1} alt="img" />
                </figure>
                <div className="d-flex align-items-center">
                  <span>Quran Online</span>
                  <h6>jan 04 2024</h6>
                </div>
                <h5>
                  <a href="#">Embarking on a Journey of Reflection</a>
                </h5>
                <div className="blog-man d-flex align-items-center">
                  <h6>
                    by<a href="#">Thomas Walimes</a>
                  </h6>
                </div>
                <p>
                  Phasellus enim libero, blandit vel sapienvitae, condimen tum
                  ultricies magna Lorem mod temincidid unt ut labore et dolore
                  magna aliqua vulputate cursus a sit am veli N nt taciti socio
                  Etiam ante ex fer mentodio Sed non erat it consequat aucto
                  odicons habitant morbi trist ique netus et malesuada. Ph
                  asellus enim liberod do eiusmod te dolore magna aliqua
                  vulputate cursus a sit am veli Nam mauctor Class aptent taciti
                  mentodio Sed non erat it consequat aucto odiconse.
                  <br />
                  <br />
                  Phasellus enim libero, blandit vel sapienvitae, condimen tum
                  ultricies magna Lore mod temincidid unt ut labore et dolore
                  magna aliqua vulputate cursus a sit am veli ent taciti socio
                  Etiam ante ex fer mentodio Sed non erat.
                </p>
              </div>
              <div className="blog-details-style">
                <ul className="list">
                  <li>Alhamdulillah 2003, kami berhasil mengumpulkan dana,</li>
                  <li>
                    21 Photography Competition, please register your details
                    through the link below.
                  </li>
                  <li>Entries close on Sunday 9th May 2021</li>
                  <li>
                    When you give your Zakat, you do more than just help someone
                  </li>
                </ul>
                <div
                  className="quote-color"
                  style={{
                    backgroundImage: `url(${colorBG})`,
                  }}
                >
                  <div>
                    <FontAwesomeIcon icon={faQuoteRight} />
                  </div>
                  <div>
                    <h5>
                      Allah knows what is the best for you and when it's best
                      for you to have it.” “One who remembers ALLAH is never
                      AloneLY.
                    </h5>
                    <h4>- Mukhti Rehman, Founder</h4>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="img-navigating hoverimg">
                      <figure>
                        <img src={blogDetail2} alt="img" />
                      </figure>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="img-navigating hoverimg">
                      <figure>
                        <img src={blogDetail3} alt="img" />
                      </figure>
                    </div>
                  </div>
                </div>
                <div className="drop-caps-work">
                  <p>
                    Lim libero, blandit vel sapienvitae, condimen tum ultricies
                    magna Lorem ididunt ut labore cursus a sit am veli Nio Etiam
                    ante ex fermentodio Sed non erat it consequat auct ique
                    netus et malesuada. Phasellus enim liberod do eiusmod te
                    dolore magna aliqua vul Phasellus enim libero, blandit vel
                    sapienvitae, condimen tum ultricies magna Lore mod
                    <br />
                    <br /> temincidindit blandit vel sapienvitae, condimen tum
                    ndit vel sultricies magna. Phasellus enim libero, blandit
                    vel sap magna aliqua vulputate cursus a sit am ndit vel
                    svelient taciti socio Etiam ante ex fermentodindit vel
                    blandit vel sapienvitae, condimen tum ultricies magna.
                  </p>
                </div>
                <div className="video position-relative">
                  <a
                    data-fancybox=""
                    href="https://www.youtube.com/watch?v=xKxrkht7CpY"
                  >
                    <i>
                      <svg
                        width="11"
                        height="17"
                        viewBox="0 0 11 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11 8.49951L0.5 0.27227L0.5 16.7268L11 8.49951Z"
                          fill="#000"
                        ></path>
                      </svg>
                    </i>
                  </a>
                  <img src={blogDetail4} alt="img" />
                </div>
                <div className="post-tags">
                  <div className="d-flex">
                    <h6>Tags:</h6>
                    <ul className="tags">
                      <li>
                        <a href="#">Islamic</a>
                      </li>
                      <li>
                        <a href="#">Classes</a>
                      </li>
                      <li>
                        <a href="#">Prayers</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="sidebar">
                <h3>Recent Posts</h3>
                <div className="boder-bar"></div>
                <ul className="recent-post">
                  <li>
                    <img alt="recent-posts-img" src={blogDetail1} />
                    <div>
                      <a href="#">The Five Pillars are the core beliefs</a>
                      <span>March 02, 2024</span>
                    </div>
                  </li>
                  <li>
                    <img alt="recent-posts-img" src={blogDetail2} />
                    <div>
                      <a href="#">Islam means to achieve peace</a>
                      <span>March 02, 2024</span>
                    </div>
                  </li>
                  <li>
                    <img alt="recent-posts-img" src={blogDetail3} />
                    <div>
                      <a href="#">Peace with the creations of God</a>
                      <span>March 02, 2024</span>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="sidebar">
                <h3>Categories</h3>
                <div className="boder-bar"></div>
                <ul className="categories">
                  <li>
                    <a href="#">
                      Classes<span>23</span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      Islamic<span>10</span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      Quran Tilawat<span>09</span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      Religious<span>14</span>
                    </a>
                  </li>
                  <li className="mb-0">
                    <a href="#">
                      Prayers<span>12</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogDetails;
